import React, { useEffect, useRef, useState } from "react";
import moment from "moment";
import { useDispatch, useSelector } from "react-redux";
// import CustomModal from "components/CustomModal";
import C from "Constants";
import { t } from "i18next";
import { UTILS } from "utils";
// import Close from "icons/Close";
import { orderTimingAction } from "store/actions";
import { FormatPreOrderingTime } from "utils/OrderUtils";
import SlideInLayout, {
  SlideInHeader,
  SlideInFooter,
} from "components/layouts/SlideInLayout";
import { TranslationText } from "components/TextTranslationContainer";
import { CustomButton } from "components/Button";
import ConditionalRenderer from "components/ConditionalRenderer";
import { RadioOption } from "components/RadioButton";

// TODO: requires code cleanup

const SlotOptions = ({ onClick, index, content, isSelected }) => {
  return (
    <>
      <li
        key={index}
        className={`cursor-pointer text-center font-normal mb-2 p-2 rounded-16x transition-all border-[1.5px]  ${
          isSelected
            ? "bg-brand-light-base-primary  border-brand-base-primary text-brand-base-primary"
            : "bg-gray-100 text-gray-600 border-gray-300"
        }`}
        onClick={onClick}
      >
        {content}
      </li>
    </>
  );
};

const SlotList = ({
  availableSlots,
  selectedOption: orderTiming,
  setSelectedOption=()=>{}
}) => {
  const changeSlotDay = (day, slotIndex) => {
    //if same day is selected then do nothing
    if (orderTiming?.preOrderSlot?.day === day) return;
    const slot = {
      day,
      time: availableSlots[slotIndex]?.slots[0],
      slotIndex,
    };

    const orderTimingObj = {
      TimingType: C.ORDER_TIMING_TYPE.PREORDER,
      isPreOrderAvailable: true,
      preOrderSlot: slot,
    };

    setSelectedOption(orderTimingObj);
  };
  const changeSlotTiming = (time, day, slotIndex) => {
    if (orderTiming?.preOrderSlot?.time === time) return;
    const orderTimingObj = {
      TimingType: C.ORDER_TIMING_TYPE.PREORDER,
      isPreOrderAvailable: true,
      preOrderSlot: {
        day,
        time,
        slotIndex,
      },
    };

    setSelectedOption(orderTimingObj);
  };

  return (
    <>
      <div className="grid grid-cols-2 gap-2 py-2">
        {/* Left side - Day List */}
        <ul
          className="list-none"
          style={{ maxHeight: "200px", overflowY: "auto", paddingRight: "8px" }}
        >
          {availableSlots.map((daySlot, index) => (
            <SlotOptions
              key={index}
              onClick={() => changeSlotDay(daySlot.day, index)}
              isSelected={orderTiming?.preOrderSlot?.slotIndex === index}
              index={index}
              content={
                daySlot.day === C.TODAY
                  ? t(daySlot.day)
                  : moment(daySlot.day).format("dddd, DD MMM YYYY")
              }
            />
          ))}
        </ul>

        {/* Right side - Slots */}
        <ul
          className="list-none"
          style={{ maxHeight: "200px", overflowY: "auto", paddingRight: "8px" }}
        >
          {availableSlots[
            orderTiming?.preOrderSlot?.slotIndex || 0
          ]?.slots?.map((time, slotIndex) => (
            <SlotOptions  
              onClick={() =>
                changeSlotTiming(
                  time,
                  availableSlots[orderTiming?.preOrderSlot?.slotIndex]?.day,
                  orderTiming?.preOrderSlot?.slotIndex
                )
              }
              key={slotIndex}
              content={FormatPreOrderingTime(time)}
              isSelected={orderTiming?.preOrderSlot?.time === time}
            />
          ))}
        </ul>
        {/* <div className="w-1/2 px-4 py-1 rounded-r-lg list-disc">
          {orderTiming?.TimingType !== null && (
            <ul className="list-disc">
              <div style={{ maxHeight: "200px", overflowY: "auto" }}>
                {availableSlots[
                  orderTiming?.preOrderSlot?.slotIndex || 0
                ]?.slots?.map((time, slotIndex) => (
                  <li
                    onClick={() =>
                      changeSlotTiming(
                        time,
                        availableSlots[orderTiming?.preOrderSlot?.slotIndex]
                          ?.day,
                        orderTiming?.preOrderSlot?.slotIndex
                      )
                    }
                    key={slotIndex}
                    className={`scroll-x font-normal cursor-pointer mb-2 p-2 text-center rounded-md transition-all  ${
                      orderTiming?.preOrderSlot?.time === time
                        ? "bg-brand-base-primary text-brand-text-primary"
                        : "bg-gray-100 text-gray-600"
                    }`}
                  >
                    {FormatPreOrderingTime(time)}
                  </li>
                ))}
              </div>
            </ul>
          )}
        </div> */}
      </div>
    </>
  );
};

// this is used to select the time for delivery/pickup
const PreOrderingSlotWidget = ({
  isPreOrderingSlotWidget,
  setPreOrderingSlotWidget,
  selectedStore,
}) => {
  const elementRef = useRef(null);
  const dispatch = useDispatch();
  const [selectedOption, setSelectedOption] = useState(null);
  const { orderType } = useSelector((state) => state.AppReducer);
  const { orderTiming } = useSelector((state) => state?.orderTimingReducer);

  const validatePreOrdering = () => {
    if (
      orderTiming?.TimingType === C.ORDER_TIMING_TYPE.PREORDER &&
      orderTiming?.preOrderSlot?.day &&
      orderTiming?.preOrderSlot?.time &&
      orderTiming?.preOrderSlot?.slotIndex !== null
    ) {
      // setPreOrderingSlotWidget(false);
      return true;
    } else if (
      orderTiming?.TimingType === C.ORDER_TIMING_TYPE.ASAP &&
      selectedStore?.isOpened
    ) {
      // WsetPreOrderingSlotWidget(false);
      return true;
    } else {
      UTILS.errorNotification("Please select a slot", "top-center");
      return false;
    }
  };

  const handleAsapOrders = (e, isChecked) => {
    if (!isChecked) return;
    const obj = {
      TimingType: isChecked ? C.ORDER_TIMING_TYPE.ASAP : null,
      isPreOrderAvailable: false,
      preOrderSlot: {
        day: null,
        time: null,
        slotIndex: null,
      },
    };
    setSelectedOption(obj);
    // dispatch(orderTimingAction.setOrderTiming(obj));
  };

  const handlePreOrders = (e, isChecked = false) => {
    if (!isChecked) return;
    let obj = null;
    if (orderType?.serviceType === C.SERVICE_TYPE.DELIVERY) {
      obj = {
        TimingType: isChecked ? C.ORDER_TIMING_TYPE.PREORDER : null,
        isPreOrderAvailable: true,
        preOrderSlot: {
          day: isChecked
            ? selectedStore?.availablePreOrderSlotsForDelivery[0]?.day
            : null,
          time: isChecked
            ? selectedStore?.availablePreOrderSlotsForDelivery[0]?.slots[0]
            : null,
          slotIndex: isChecked ? 0 : null,
        },
      };
      // dispatch(orderTimingAction.setOrderTiming(obj));
    }
    if (orderType?.serviceType === C.SERVICE_TYPE.PICKUP) {
      obj = {
        TimingType: isChecked ? C.ORDER_TIMING_TYPE.PREORDER : null,
        isPreOrderAvailable: true,
        preOrderSlot: {
          day: isChecked
            ? selectedStore?.availablePreOrderSlotsForPickup[0]?.day
            : null,
          time: isChecked
            ? selectedStore?.availablePreOrderSlotsForPickup[0]?.slots[0]
            : null,
          slotIndex: isChecked ? 0 : null,
        },
      };
      // dispatch(orderTimingAction.setOrderTiming(obj));
    }
    if (obj) {
      setSelectedOption(obj);
    }
  };

  const handleConfirm = () => {
    if(validatePreOrdering()){
      dispatch(orderTimingAction.setOrderTiming(selectedOption));
      setPreOrderingSlotWidget(false);
    }
  }

  const baseData = {
    [C.SERVICE_TYPE.DELIVERY]: {
      title: "Delivery Timing",
      description: "Schedule when you want to receive the order",
      availableSlots: selectedStore?.availablePreOrderSlotsForDelivery,
    },
    [C.SERVICE_TYPE.PICKUP]: {
      title: "Pickup Timing",
      description: "Schedule when you want to pickup the order",
      availableSlots: selectedStore?.availablePreOrderSlotsForPickup,
    },
  };
  
  useEffect(() => {
    if (selectedStore?.isOpened || orderTiming?.TimingType) {
      if(orderTiming?.TimingType === C.ORDER_TIMING_TYPE.PREORDER){
        handlePreOrders(null, true);
      }
      if(orderTiming?.TimingType === C.ORDER_TIMING_TYPE.ASAP){
        handleAsapOrders(null, true);
      }
    }
  }, [selectedStore?.isOpened && orderTiming?.TimingType]);

  return (
    <SlideInLayout
      open={isPreOrderingSlotWidget}
      hideOutsideCloseButton={true}
      container={{
        style: {
          height: "fit-content",
        },
      }}
    >
      <SlideInHeader
        title={baseData[orderType?.serviceType]?.title}
        containerStyleProps={{
          className: "pb-0",
        }}
        onClose={() => setPreOrderingSlotWidget(false)}
      />
      <div ref={elementRef} id="discount-info-popup" className="px-4 py-3">
        <TranslationText
          text={baseData[orderType?.serviceType]?.description}
          as="p"
        />
        <ConditionalRenderer condition={!selectedStore?.isOpened && !orderTiming?.TimingType}>
          <TranslationText
            text="Store is closed, Please try again later or try another store"
            className="text-center text-red-500 p-4"
            as="p"
          />
        </ConditionalRenderer>
        {/* slots options */}
        <ConditionalRenderer
          condition={selectedStore?.isOpened}
          // elseComponent={
          //   <TranslationText
          //     text="Store is closed, Please try again later or try another store"
          //     className="text-center text-red-500 p-4"
          //     as="p"
          //   />
          // }
        >
          <RadioOption
            label="ASAP"
            value="asap"
            onClick={(e) =>
              handleAsapOrders(
                e,
                !(selectedOption?.TimingType === C.ORDER_TIMING_TYPE.ASAP)
              )
            }
            checked={selectedOption?.TimingType === C.ORDER_TIMING_TYPE.ASAP}
          />
          <ConditionalRenderer
            condition={
              (orderType?.serviceType === C.SERVICE_TYPE.DELIVERY &&
                selectedStore?.availablePreOrderSlotsForDelivery?.length > 0) ||
              (orderType?.serviceType === C.SERVICE_TYPE.PICKUP &&
                selectedStore?.availablePreOrderSlotsForPickup?.length > 0)
            }
          >
            <RadioOption
              label="Later (Future orders)"
              value="Later (Future orders)"
              onClick={(e) =>
                handlePreOrders(
                  e,
                  !(selectedOption?.TimingType === C.ORDER_TIMING_TYPE.PREORDER)
                )
              }
              checked={
                selectedOption?.TimingType === C.ORDER_TIMING_TYPE.PREORDER
              }
            />
          </ConditionalRenderer>
        </ConditionalRenderer> 
        <ConditionalRenderer
          condition={
            selectedOption?.TimingType === C.ORDER_TIMING_TYPE.PREORDER 
          }
          elseComponent={
            selectedOption?.TimingType !== C.ORDER_TIMING_TYPE.ASAP &&
            <TranslationText
              text="No Slots Available"
              className="text-center text-red-500 p-4"
              as="p"
            />
          }
        >
          <SlotList
            availableSlots={baseData[orderType?.serviceType]?.availableSlots}
            selectedOption={selectedOption}
            setSelectedOption={setSelectedOption}
          />
        </ConditionalRenderer>
      </div>
      <SlideInFooter
        containerStyleProps={{
          style: {
            position: "sticky",
          },
        }}
      >
        <CustomButton disabled={!selectedStore?.isOpened && !selectedOption?.TimingType} onClick={handleConfirm}>
          <TranslationText text="Confirm" />
        </CustomButton>
      </SlideInFooter>
    </SlideInLayout>
  );
};

export default PreOrderingSlotWidget;
